import React from 'react';
import { createRoot } from 'react-dom/client';
import Loading from './Loading';
import PreventEventObserver from '../../../shared/utils/preventEventObserver';

export default class BodyLoading {
    #unmount = undefined

    #count = 0

    #containerClassName = undefined

    #preventObserver = undefined;

    constructor(containerClassName) {
      this.#containerClassName = containerClassName;
    }

  #mount() {
      const container = document.querySelector(`.${this.#containerClassName}`);
      const div = document.createElement('div');
      div.className = 'checkout-ui-component';
      container && container.appendChild(div);

      const root = createRoot(div);
      root.render(<Loading />);
      this.#preventObserver = new PreventEventObserver([ 'keydown' ], container);
      this.#preventObserver.observe();
      return () => {
        this.#unmount = null;
        root.unmount();
        div.parentNode && div.parentNode.removeChild(div);
      };
    }

  show() {
    if (!this.#unmount) {
      this.#unmount = this.#mount();
    }
    this.#count++;
  }

  hide() {
    if (--this.#count <= 0) {
      this.#unmount?.();
      this.#preventObserver?.unobserve();
    }
  }

  clear() {
    this.#count = 0;
    this.#unmount?.();
  }
}
